import { render, staticRenderFns } from "./StarterCoursePicker.vue?vue&type=template&id=6193ac37&scoped=true"
import script from "./StarterCoursePicker.vue?vue&type=script&lang=js"
export * from "./StarterCoursePicker.vue?vue&type=script&lang=js"
import style0 from "./StarterCoursePicker.vue?vue&type=style&index=0&id=6193ac37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6193ac37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
